module.exports = __webpack_public_path__ + "img/9.b57cf022.jpg";